import React from 'react';
import { useAppSelector } from '../../../store';

type Props = {
    title: string;
    subtitle?: string;
    /** When false, omit bottom border (e.g. inside another bordered bar). */
    showBottomBorder?: boolean;
    className?: string;
};

/**
 * Bank logo (or initial) + menu title row for sidebar tops (PSO / Regional / Incharge, etc.).
 */
export default function SidebarBankHeader({
    title,
    subtitle,
    showBottomBorder = true,
    className,
}: Props) {
    const bank = useAppSelector((s) => s.user.bank);
    const logo = bank?.imgUrl?.trim();
    const initial = (bank?.companyName || bank?.companyId || 'B').charAt(0).toUpperCase();

    return (
        <div
            className={[
                'flex shrink-0 items-center gap-3 px-4 py-3',
                showBottomBorder ? 'border-b border-gray-200 dark:border-white/10' : '',
                className ?? '',
            ]
                .filter(Boolean)
                .join(' ')}
        >
            {logo ? (
                <div className="flex h-10 max-w-[min(42vw,200px)] shrink-0 items-center justify-center">
                    <img
                        src={logo}
                        alt={bank?.companyName ? `${bank.companyName} logo` : 'Bank logo'}
                        className="max-h-8 w-auto max-w-[180px] object-contain object-center"
                        decoding="async"
                        loading="lazy"
                        referrerPolicy="no-referrer"
                    />
                </div>
            ) : (
                <div
                    className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-gray-200 bg-gradient-to-br from-slate-100 to-slate-200 text-sm font-bold text-slate-600 dark:border-gray-600 dark:from-slate-700 dark:to-slate-800 dark:text-slate-200"
                    aria-hidden
                >
                    {initial}
                </div>
            )}
            {/* <div className="min-w-0 flex-1">
                <div className="truncate text-sm font-semibold text-gray-900 dark:text-gray-100">{title}</div>
                {subtitle ? (
                    <div className="truncate text-xs text-gray-500 dark:text-gray-400">{subtitle}</div>
                ) : null}
            </div> */}
        </div>
    );
}
